export const SHOW_UNAVAILABLE_ITEM_MODAL = 'SHOW_UNAVAILABLE_ITEM_MODAL';

export const UNAVAILABLE_ITEM_PRIORITY = 500;
export const UNAVAILABLE_ITEM_COOKIE_KEY = 'trans_unavailableItem';
export const UNAVAILABLE_ITEM_NOTIFICATION_KEY = 'unavailableItem';
